import { render, staticRenderFns } from "./change-plan-item.vue?vue&type=template&id=87fe9654&scoped=true&"
import script from "./change-plan-item.vue?vue&type=script&lang=ts&"
export * from "./change-plan-item.vue?vue&type=script&lang=ts&"
import style0 from "./change-plan-item.vue?vue&type=style&index=0&id=87fe9654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe9654",
  null
  
)

export default component.exports